var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeaderboard2Nd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41153 17.4999L3.1032 8.32992C2.8743 7.93427 2.76665 7.48011 2.79361 7.02381C2.82058 6.56752 2.98097 6.12919 3.25487 5.76325L5.1332 3.26659C5.35054 2.97679 5.63237 2.74159 5.95637 2.57959C6.28037 2.41759 6.63763 2.33325 6.99987 2.33325H20.9999C21.3621 2.33325 21.7194 2.41759 22.0434 2.57959C22.3674 2.74159 22.6492 2.97679 22.8665 3.26659L24.7332 5.76325C25.0089 6.12801 25.1714 6.56574 25.2004 7.02205C25.2295 7.47836 25.1238 7.93315 24.8965 8.32992L19.5882 17.4999",
    stroke: "#C0C0C0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8331 14L5.97314 2.56665",
    stroke: "#C0C0C0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1665 14L22.0265 2.56665",
    stroke: "#C0C0C0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 8.16675H18.6668",
    stroke: "#C0C0C0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 25.6667C17.2215 25.6667 19.8332 23.055 19.8332 19.8333C19.8332 16.6117 17.2215 14 13.9998 14C10.7782 14 8.1665 16.6117 8.1665 19.8333C8.1665 23.055 10.7782 25.6667 13.9998 25.6667Z",
    stroke: "#C0C0C0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 21.0001V18.6667H13.4165",
    stroke: "#C0C0C0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaderboard2Nd);
export default __webpack_public_path__ + "static/media/icon-leaderboard-2nd.1b18cdc340e33b0c6d6da54203645c62.svg";
export { ForwardRef as ReactComponent };